import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from './Footer';

const Error = () => {
    return (
        <>
        <Navigation/>
        <div className="container">
            <div className="error-content">
                <h1>404</h1>
                <h2>Page Not Found</h2>
                <p>The page you're looking for doesn't exist.</p>
                <Link to="/" className="btn-home">Go Home</Link>
            </div>
        </div>
        <Footer/>
        </>
    );
};

export default Error;